import { ArrowDownIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

interface ChatScrollToBottomButtonProps {
  isVisible: boolean
  onClick: () => void
}

export const ChatScrollToBottomButton: React.FC<ChatScrollToBottomButtonProps> = ({
  isVisible,
  onClick,
}): ReactNode => {
  if (!isVisible) return null

  return (
    <div className="absolute bottom-4 left-1/2 z-10 -translate-x-1/2">
      <Button
        variant="secondary"
        size="sm"
        className="chat-scroll-to-bottom rounded-full shadow-lg"
        onClick={onClick}
      >
        <ArrowDownIcon className="mr-1 size-4" />
        Scroll to bottom
      </Button>
    </div>
  )
}
